import { render, staticRenderFns } from "./SuccessfulCasesEdit.vue?vue&type=template&id=6f4acf8c&scoped=true&"
import script from "./SuccessfulCasesEdit.vue?vue&type=script&lang=js&"
export * from "./SuccessfulCasesEdit.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfulCasesEdit.vue?vue&type=style&index=0&id=6f4acf8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4acf8c",
  null
  
)

export default component.exports